/***************************************************************
5/22/2017
Alexander Self
Timesheet Download
- Component to allow a user to download a timesheet daily summary
   or a set of timesheets in a date range
***************************************************************/
import { DatePicker2, AutoComplete } from '../../inputs';
import { onDummyComplete, mapEmployeeForAutoComplete, findEmployeeByName } from '../../../utils';
import React from 'react';
const $ = window.$;


const TimesheetDownload = ({ id, _class, downloadTimesheets, email, label, byEmployee, employees, date1, date2 }) => {
  $(document).ready(function(){
    $(`#${id}`).collapsible();
  });
  function packageDates(callback) {
    let dateFrom = document.getElementById(date1).value;
    let dateTo = document.getElementById(date2).value;
    if (byEmployee) {
      let emp = findEmployeeByName(document.getElementById('employee-search-ts-download').value, employees);
      return callback({ dateFrom, dateTo }, email, emp);
    }
    
    return callback({ dateFrom, dateTo }, email);
  }
  return (
    <ul id={id} className={`collapsible ${_class}`} data-collapsible="accordion">
      <li>
        <div className="collapsible-header"><i className="material-icons">get_app</i>{label}</div>
        <div className="collapsible-body">
          <div className="row">
            <b>Select a date range</b><hr />
            <form id="ts-download-form" onSubmit={(e) => e.preventDefault()}>
              <DatePicker2 id={date1} label={'From'} />
              <DatePicker2 id={date2} label={'To'} />
              {
                byEmployee ?
                <div>
                  <AutoComplete id={'employee-search-ts-download'} label={'Select an Employee'}
                    data={mapEmployeeForAutoComplete(employees)}
                    onComplete={(val, id) => onDummyComplete(val, id) }
                  /> <br />
                </div> : ''
              }
              <button className="btn waves-light waves-effect"
                onClick={() => packageDates(downloadTimesheets)}>
                Email
              </button>
              <p>Send to: <b>{email}</b></p>
            </form>
          </div>
        </div>
      </li>
    </ul>
  );
};

export default TimesheetDownload;




















/* END */



// WEBPACK FOOTER //
// ./src/components/timesheets/view/timesheet_download.js